import {
  APP_LOGO_DARK,
  APP_LOGO_LIGHT,
} from "@/components/layouts/app-brand-logo";
import { useSidebarExpanded } from "@/components/layouts/use-sidebar-expanded";
import { useTheme } from "@/components/providers/use-theme";
import {
  BaseSidebarHeader,
  BaseSidebarHeaderGrid,
  Button,
} from "@cmde/shadcn";
import { MenuIcon, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function AppSidebarHeader() {
  const { theme } = useTheme();
  const { isExpanded, toggleSidebar } = useSidebarExpanded();
  const { t } = useTranslation();

  return (
    <BaseSidebarHeaderGrid
      leading={
        <Button
          variant="ghost"
          size="icon"
          className="size-8 shrink-0 text-sidebar-foreground"
          onClick={toggleSidebar}
          aria-label={isExpanded ? "Close sidebar" : "Open sidebar"}
        >
          {isExpanded ? <XIcon className="size-5" /> : <MenuIcon className="size-5" />}
        </Button>
      }
    >
      <BaseSidebarHeader
        text={t("components.sidebar.general.available_modules")}
        logoSrc={APP_LOGO_LIGHT}
        logoSrcDark={APP_LOGO_DARK}
        logoSize="sm"
        theme={theme}
      />
    </BaseSidebarHeaderGrid>
  );
}
